import React from "react";
import { RouteObject } from "react-router-dom";

import {
  checkAnyScope,
  checkBooleanScope,
} from "@src/components/LimitAccess/check-scopes";

import { PERSONALIZATION_ROUTES } from "../../routes";

export const PersonalizationNonPaddedRoutes: RouteObject[] = [
  {
    path: PERSONALIZATION_ROUTES.Personalization,
    lazy: async () => {
      const { PersonalizationExperienceRoute } =
        await import("../../../features/personalizations/pages/personalizationExperience/PersonalizationExperience.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            debugId={PERSONALIZATION_ROUTES.Personalization}
            isEnabled={({ org }) =>
              checkAnyScope([
                checkBooleanScope("personalizations", org.configurations),
              ])
            }
            children={PersonalizationExperienceRoute}
          />
        ),
      };
    },
  },
  {
    path: PERSONALIZATION_ROUTES.Personalization_Id,
    lazy: async () => {
      const { PersonalizationExperienceRoute } =
        await import("../../../features/personalizations/pages/personalizationExperience/PersonalizationExperience.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            debugId={PERSONALIZATION_ROUTES.Personalization_Id}
            children={PersonalizationExperienceRoute}
            isEnabled={({ org }) =>
              checkAnyScope([
                checkBooleanScope("personalizations", org.configurations),
              ])
            }
          />
        ),
      };
    },
  },
];
